import { render, staticRenderFns } from "./TireConfirmTerm.vue?vue&type=template&id=236fcf96&scoped=true"
import script from "./TireConfirmTerm.vue?vue&type=script&lang=ts"
export * from "./TireConfirmTerm.vue?vue&type=script&lang=ts"
import style0 from "./TireConfirmTerm.vue?vue&type=style&index=0&id=236fcf96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236fcf96",
  null
  
)

export default component.exports